<script lang="ts">
    // Skeleton loader for the Sign Petition page
    // Mimics the actual layout: Hero + Description on left, Form on right
</script>

<div class="bg-gray-50 animate-pulse" data-testid="sign-page-skeleton-loader">
    <div class="max-w-6xl mx-auto">
        <!-- Back Button (Mobile) -->
        <div class="px-4 py-3 md:hidden">
            <div class="flex items-center gap-2">
                <div class="w-5 h-5 bg-gray-300 rounded"></div>
                <div class="h-4 w-32 bg-gray-300 rounded"></div>
            </div>
        </div>

        <!-- Split Layout -->
        <div class="flex flex-col lg:flex-row">
            <!-- Left Side: Hero + Content -->
            <div class="lg:w-1/2">
                <div class="p-4 lg:p-8">
                    <!-- Back Button (Desktop) -->
                    <div class="hidden md:flex items-center gap-2 mb-6">
                        <div class="w-5 h-5 bg-gray-300 rounded"></div>
                        <div class="h-4 w-32 bg-gray-300 rounded"></div>
                    </div>

                    <!-- Hero Banner Skeleton -->
                    <div class="relative rounded-xl overflow-hidden bg-gray-300 h-48 md:h-56 lg:h-64">
                        <!-- Featured badge -->
                        <div class="absolute top-4 left-4">
                            <div class="h-6 w-24 bg-gray-400/50 rounded-full"></div>
                        </div>
                        <!-- Title area at bottom -->
                        <div class="absolute bottom-0 left-0 right-0 p-4 lg:p-6">
                            <div class="h-8 w-3/4 bg-gray-400/50 rounded mb-2"></div>
                            <div class="flex items-center gap-4">
                                <div class="h-4 w-20 bg-gray-400/50 rounded"></div>
                                <div class="h-4 w-24 bg-gray-400/50 rounded"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Description Skeleton -->
                    <div class="mt-6 space-y-3">
                        <div class="h-4 bg-gray-300 rounded w-full"></div>
                        <div class="h-4 bg-gray-300 rounded w-5/6"></div>
                        <div class="h-4 bg-gray-300 rounded w-4/5"></div>
                        <div class="h-4 bg-gray-300 rounded w-full"></div>
                        <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                    </div>

                    <!-- Petition Text Box Skeleton -->
                    <div class="mt-6 bg-gray-200 border border-gray-300 rounded-xl overflow-hidden">
                        <!-- Header -->
                        <div class="px-5 py-3 bg-gray-300 border-b border-gray-300">
                            <div class="flex items-center gap-2">
                                <div class="w-4 h-4 bg-gray-400 rounded"></div>
                                <div class="h-4 w-24 bg-gray-400 rounded"></div>
                            </div>
                        </div>
                        <!-- Content -->
                        <div class="p-5 space-y-2">
                            <div class="h-3 bg-gray-300 rounded w-full"></div>
                            <div class="h-3 bg-gray-300 rounded w-5/6"></div>
                            <div class="h-3 bg-gray-300 rounded w-full"></div>
                            <div class="h-3 bg-gray-300 rounded w-4/5"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Side: Form -->
            <div class="lg:w-1/2 bg-white lg:border-l border-gray-200">
                <div class="p-4 lg:p-8">
                    <!-- Section Header -->
                    <div class="mb-6">
                        <div class="h-7 w-48 bg-gray-300 rounded mb-2"></div>
                        <div class="h-4 w-64 bg-gray-200 rounded"></div>
                    </div>

                    <!-- Form Fields Skeleton -->
                    <div class="space-y-5">
                        <!-- Name row -->
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <div class="h-4 w-20 bg-gray-300 rounded mb-2"></div>
                                <div class="h-11 bg-gray-200 rounded-lg"></div>
                            </div>
                            <div>
                                <div class="h-4 w-20 bg-gray-300 rounded mb-2"></div>
                                <div class="h-11 bg-gray-200 rounded-lg"></div>
                            </div>
                        </div>

                        <!-- Email -->
                        <div>
                            <div class="h-4 w-16 bg-gray-300 rounded mb-2"></div>
                            <div class="h-11 bg-gray-200 rounded-lg"></div>
                        </div>

                        <!-- Address -->
                        <div>
                            <div class="h-4 w-28 bg-gray-300 rounded mb-2"></div>
                            <div class="h-11 bg-gray-200 rounded-lg"></div>
                        </div>

                        <!-- ZIP -->
                        <div class="w-1/3">
                            <div class="h-4 w-20 bg-gray-300 rounded mb-2"></div>
                            <div class="h-11 bg-gray-200 rounded-lg"></div>
                        </div>

                        <!-- Checkboxes -->
                        <div class="space-y-3 pt-2">
                            <div class="flex items-center gap-3">
                                <div class="w-5 h-5 bg-gray-300 rounded"></div>
                                <div class="h-4 w-48 bg-gray-200 rounded"></div>
                            </div>
                            <div class="flex items-center gap-3">
                                <div class="w-5 h-5 bg-gray-300 rounded"></div>
                                <div class="h-4 w-32 bg-gray-200 rounded"></div>
                            </div>
                        </div>

                        <!-- Submit Button -->
                        <div class="pt-4">
                            <div class="h-12 bg-gray-300 rounded-lg w-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

